module.exports = __webpack_public_path__ + "img/home_todo_item1.fa365c8f.png";